/* global path_to_cross, filter_reset_copy */

import $ from 'jquery';

var product_filter = function () {
  var self = this;
  this.filter = {
    age: [],
    gender: [],
    dosage_form: [],
    area_of_application: [],
  };

  this.templates = {
    results: {
      headline: '<h4 class="d-lg-none __text-class__">__headline__</h4>',
      content: '<div id="__result_category_id__" class="products-overview mx-n4 mx-lg-0"></div>',
      batch:
        '<span class="badge bg-orthomol-blue text-white d-flex align-items-center mw-100">\n' +
        '<span class="filter-category-title text-truncate pt-1">__batch_names__</span>' +
        '<button class="icon __spacer__ me-0 reset-filter-batch bg-transparent text-white border-0 focus-visible" data-attr-filter-name="__filter_name__">' +
          path_to_cross +
        '</button>\n' +
        '</span>',
      reset:
        '<button class="badge text-orthomol-blue d-flex align-items-center reset-all-filter focus-visible border-0 bg-transparent">\n' +
        '<span class="filter-category-title order-1 pt-1">' +
          filter_reset_copy +
        '</span>\n' +
        '<span class="icon ms-0 me-2">' +
          path_to_cross +
        '</span>\n' +
        '</button>',
    },
  };

  this.init = function () {
    console.log('__init__');

    $('.filter-option-list-item').hide();

    // ORT-3055: the overview cards carry live Preact add-to-cart islands, so the filter must not clone them
    // (a clone has no event listeners -> dead cart button, frozen price). Instead the real card elements are
    // moved into .filter-results and moved back here. Remember each holder's original child order for that.
    this.holders = Array.from(document.querySelectorAll('.products-overview-holder')).map(function (holder) {
      return { holder: holder, children: Array.from(holder.children) };
    });

    $('.products-box')
      .toArray()
      .forEach(function (item) {
        Object.values(item.attributes).forEach(function (item) {
          if (item.name.startsWith('data-attr')) {
            let identifier = 'filter-option-' + item.name.replace('data-attr-', '');
            $('#' + identifier).show();
          }
        });
      });

    $('.filter_option').on('change', function (e) {
      self.onFilterChange(e);
      self.updateFilter(e);
    });

    $('.apply_filter').on('click', function (e) {
      e.target.closest('.filter-category-items').setAttribute('hidden', true);
      e.target.closest('.filter-category').querySelector('button').setAttribute('aria-expanded', false);
      e.target.closest('.filter-category').querySelector('button').focus();
      self.updateFilter(e);
    });

    const filterCategoryToggleMobile = document.getElementById('filter-category-toggle-mobile');
    document.querySelector('.apply_filter_mobile').addEventListener('click', () => {
      this.updateFilter();
      filterCategoryToggleMobile.checked = false;
    });

    // Close filter dropdowns when clicking outside of them
    addEventListener('click', (event) => {
      const isInsideDropdown = event.target.closest('.filter-category');
      if (!isInsideDropdown) {
        // Close all dropdowns
        const openDropdowns = document.querySelectorAll('.filter-category-items:not([hidden])');
        openDropdowns.forEach(dropdown => {
          dropdown.setAttribute('hidden', true);
          document.getElementById(dropdown.id + '-toggle').setAttribute('aria-expanded', false);
        });
      }
    });

    $('body').on('click', '.reset-filter-batch', function (e) {
      self.clearFilter($(e.currentTarget).data('attr-filter-name'));
    });

    $('body').on('click', '.reset-all-filter', function () {
      self.clearAllFilter();
    });
  }.bind(this);

  // Move every card back into its category holder at its original position (no-op for cards already there).
  this.restoreProducts = function () {
    this.holders.forEach(function (entry) {
      entry.children.forEach(function (child, index) {
        if (entry.holder.children[index] !== child) {
          entry.holder.insertBefore(child, entry.holder.children[index] || null);
        }
      });
    });
  }.bind(this);

  this.onFilterChange = function (e) {
    self.restoreProducts();
    $('.filter-results').empty();
    $('.filter-category-selection').empty();
    var type = $(e.target).data('filter-type');
    var value = $(e.target).data('filter-value');
    var checked = $(e.target).is(':checked');

    if (checked) {
      this.filter[type].push(value);
    } else {
      const index = this.filter[type].indexOf(value);
      if (index > -1) {
        this.filter[type].splice(index, 1);
      }
    }

    const matchedProducts = self.matchProducts();
    if (matchedProducts.length === 0) {
      $('.products-overview').show();
      return;
    }
    $('.products-overview').hide();
    let productsInCategories = {};

    matchedProducts.forEach(function (item) {
      let jItem = $(item);

      if (
        !Object.prototype.hasOwnProperty.call(productsInCategories, 'category-' + jItem.data('product-category-id'))
      ) {
        productsInCategories['category-' + jItem.data('product-category-id')] = {
          headline: self.templates.results.headline
            .replace('__headline__', jItem.data('product-category-name'))
            .replace('__text-class__', jItem.data('product-bg-class')),
          content: self.templates.results.content.replace(
            '__result_category_id__',
            'results_' + jItem.data('product-category-id')
          ),
          'content-id': 'results_' + jItem.data('product-category-id'),
          items: [],
        };
      }

      // the real element, not a clone: keeps the Preact island (price + cart button) alive
      productsInCategories['category-' + jItem.data('product-category-id')]['items'].push(item);
    });

    Object.keys(productsInCategories).forEach(function (key) {
      let product = productsInCategories[key];
      $('.filter-results').append(product.headline);
      $('.filter-results').append(product.content);
      product.items.forEach(function (item) {
        $('#' + product['content-id']).append(item);
      });
    });

    let filterBatches = {};
    $('.filter_option:checked')
      .toArray()
      .forEach(function (item) {
        if (!Object.prototype.hasOwnProperty.call(filterBatches, $(item).data('filter-type'))) {
          filterBatches[$(item).data('filter-type')] = [];
        }
        filterBatches[$(item).data('filter-type')].push($(item).data('filter-name'));
      });

    let counter = 0;
    Object.keys(filterBatches).forEach(function (key) {
      let spacer = '';
      counter++;
      if (counter > 1) {
        spacer = 'ms-4';
      }

      filterBatches[key].forEach(function (item) {
        $('.filter-category-selection').append(
          self.templates.results.batch
            .replace('__filter_name__', item)
            .replace('__batch_names__', item)
            .replace('__spacer__', spacer)
        );
      });
    });
    $('.filter-category-selection').append(self.templates.results.reset);
  }.bind(this);

  this.updateFilter = function () {
    Object.keys(self.filter).forEach((filter) => {
      const filterCheckboxes = $(`.filter_option[data-filter-type="${filter}"]`);
      const products = self.matchProducts(filter);
      if (!products.length) {
        filterCheckboxes.prop('disabled', false);
        return;
      }
      const filterAttributesStart = `data-attr-${filter}-`;
      const productsAttributes = [];

      products.forEach(function (item) {
        item.getAttributeNames().forEach(function (attribute) {
          if (attribute.startsWith(filterAttributesStart)) {
            productsAttributes.push(attribute);
          }
        });
      });

      let uniqueItems = [...new Set(productsAttributes)];
      var checkboxStr = '';
      uniqueItems.forEach(function (item) {
        checkboxStr += '[data-filter-value="' + item + '"],';
      });
      checkboxStr = checkboxStr.substring(0, checkboxStr.length - 1);

      filterCheckboxes.not(checkboxStr).prop('disabled', true);
      filterCheckboxes.filter(checkboxStr).prop('disabled', false);
    });
  }.bind(this);

  this.matchProducts = (excludedFilter = '') => {
    const cartesian = (...a) => a.reduce((a, b) => a.flatMap((d) => b.map((e) => [d, e].flat())));

    const params = [];

    Object.entries(this.filter).forEach(([filter, values]) => {
      if (filter !== excludedFilter && values.length > 0) {
        params.push(values);
      }
    });

    if (params.length === 0) {
      return [];
    }

    let output = cartesian.apply(this, params);
    let filterstring = '';

    if (!Array.isArray(output[0])) {
      output.forEach(function (item) {
        filterstring += '[' + item + '],';
      });
    } else {
      output.forEach(function (item) {
        var categoryString = '';
        item.forEach(function (group) {
          categoryString += '[' + group + ']';
        });
        filterstring += categoryString + ',';
      });
    }

    filterstring = filterstring.substring(0, filterstring.length - 1);
    return $('.products-box').filter(filterstring).toArray();
  };

  this.clearFilter = function (filterName) {
    $('.filter_option')
      .filter('[data-filter-name="' + filterName + '"]')
      .prop('checked', false)
      .change();
  }.bind(this);

  this.clearAllFilter = function () {
    $('.filter_option').prop('checked', false).change();
  }.bind(this);

  this.init();
};

if (document.querySelector('.products-overview-filter') && !document.querySelector('.treuebonus-shop-filter')) {
  new product_filter();
}
